<template>
  <div class="etapa02" :value="idPublicacao" :controlePage="controlePage">
    <fccTable
      striped
      hover
      :fields="fields"
      :actions="actions"
      addFilter
      :items="listagemDataPublicacao"
    >
    </fccTable>
    <form @submit.prevent="alteraPublicacao" autocomplete="off">
      <div class="row">
        <div class="col-sm-6 mt-1">
          <div class="publicaBox">
            <span><strong>Início Geração de Boleto(*)</strong></span>
            <div class="row">
              <div class="col-sm-12 mt-1">
                <datetime
                  value-zone="America/Sao_Paulo"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                  class="form-control"
                  placeholder="__/__/____ __:__"
                  v-model="datapagamentoboleto"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mt-1">
          <div class="publicaBox">
            <span><strong>Término Geração de Boleto(*)</strong></span>
            <div class="row">
              <div class="col-sm-12 mt-1">
                <datetime
                  value-zone="America/Sao_Paulo"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                  class="form-control"
                  placeholder="__/__/____ __:__"
                  v-model="boletohorario"
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 mt-1">
          <div class="publicaBox">
            <span><strong>Confirmação do pagamento(*)</strong></span>
            <div class="row">
              <div class="col-sm-12 mt-1">
                <datetime
                  value-zone="America/Sao_Paulo"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                  class="form-control"
                  placeholder="__/__/____ __:__"
                  v-model="dataconfirmacaopagamento"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 mt-1">
          <div class="publicaBox">
            <span><strong>Pix Data de Pagamento(*)</strong></span>
            <div class="row">
              <div class="col-sm-12 mt-1">
                <datetime
                  value-zone="America/Sao_Paulo"
                  type="datetime"
                  format="dd/MM/yyyy HH:mm"
                  class="form-control"
                  placeholder="__/__/____ __:__"
                  v-model="pixHorario"
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2 ml-auto text-right mt-3">
          <fccButton tipo="submit"> {{ labelsSystem.salvar }}</fccButton>
        </div>
      </div>
    </form>
    <fccModal
      centered
      idModal="addFieldModal"
      titleModal="Nova Data"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="criarPublicacao" autocomplete="off">
        <div class="my-2">
          <div class="row my-2" v-if="liberaPublicacao">
            <div class="col-sm-12">
              Tipo de Publicação (*)
              <fccDataTipoPublicacao
                v-on:changesDataTipoPublicacao="changeDataTipoPublicacao"
              ></fccDataTipoPublicacao>
              {{ criar.idpublicdatatipo }}
              <input v-model="criar.idpublicdatatipo" type="hidden" />
            </div>
          </div>
          <div class="row my-2">
            <div class="col-sm-12">
              <div class="publicaBox">
                <span class="titlePublicaBox">{{ textoPublicacao }}</span>
                <div class="row">
                  <div class="col-sm-6 mt-4 fccSirsdate">
                    Data início
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      :min-datetime="dataAtualSGP"
                      v-model="criar.dtinicio"
                      required
                    />
                  </div>
                  <div class="col-sm-6 mt-4 fccSirsdate" v-if="criar.dtinicio">
                    Horário Inicial
                    <datetime
                      id="horaInicial"
                      type="time"
                      format="HH:mm"
                      class="form-control"
                      value-zone="America/Sao_Paulo"
                      required
                      placeholder="__:__"
                      v-model="horaInicial"
                    />
                  </div>
                </div>
                <div class="row" v-if="criar.dtinicio">
                  <div class="col-sm-6 mt-4 fccSirsdate">
                    <div class="closeDataInput" v-if="criar.dtfim">
                      <a @click="criar.dtfim = ''"><font-awesome-icon icon="times" /></a>
                    </div>
                    Data Fim
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      :min-datetime="criar.dtinicio"
                      v-model="criar.dtfim"
                    />
                  </div>
                  <div class="col-sm-6 mt-4 fccSirsdate" v-if="criar.dtfim">
                    Horário Final
                    <datetime
                      id="horaFinal"
                      type="time"
                      format="HH:mm"
                      class="form-control"
                      value-zone="America/Sao_Paulo"
                      required
                      placeholder="__:__"
                      v-model="horaFinal"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">
                {{ labelsSystem.criar }}</fccButton
              >
            </div>
          </div>
        </div>
      </form>
    </fccModal>
    <fccModal
      centered
      idModal="editFieldModal"
      titleModal="Editar Data"
      escondeFooter
      travaEsc
      travaBack
    >
      <form @submit.prevent="editarPublicacao" autocomplete="off">
        <div class="my-2">
          <div class="row my-2">
            <div class="col-sm-12">
              <div class="publicaBox">
                <span class="titlePublicaBox">{{ editTextoPublicacao }}</span>
                <div class="row">
                  <div class="col-sm-6 mt-4 fccSirsdate">
                    Data Inicial
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      v-model="editar.dtinicio"
                      required
                    />
                  </div>
                  <div class="col-sm-6 mt-4 fccSirsdate" v-if="editar.dtinicio">
                    Horário Inicial
                    <datetime
                      id="horaInicial"
                      type="time"
                      format="HH:mm"
                      class="form-control"
                      value-zone="America/Sao_Paulo"
                      required
                      placeholder="__:__"
                      v-model="horaInicialPadrao"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 mt-4 fccSirsdate">
                    <div class="closeDataInput" v-if="editar.dtfim">
                      <a @click="editar.dtfim = ''"><font-awesome-icon icon="times" /></a>
                    </div>
                    Data Fim
                    <datetime
                      value-zone="America/Sao_Paulo"
                      type="date"
                      :min-datetime="editar.dtinicio"
                      format="dd/MM/yyyy"
                      class="form-control"
                      placeholder="__/__/____"
                      v-model="editar.dtfim"
                      required
                    />
                  </div>
                  <div class="col-sm-6 mt-4 fccSirsdate" v-if="editar.dtfim">
                    Horário Final
                    <datetime
                      id="horaFinal"
                      type="time"
                      format="HH:mm"
                      class="form-control"
                      value-zone="America/Sao_Paulo"
                      required
                      placeholder="__:__"
                      v-model="horaFinalPadrao"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton classeAdd="form-control" tipo="submit">
                {{ labelsSystem.editar }}</fccButton
              >
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import fccDataTipoPublicacao from '@/fccComponents/global/fccSpi/fccDataTipoPublicacao.vue'

export default {
  data() {
    return {
      liberaPublicacao: '1',
      textoPublicacao: 'Publicação',
      baseUrlPublicacao: '',
      editTextoPublicacao: '',
      listagemDataPublicacao: [],
      dataAtualSGP: this.capturaDataAtualSGP(),
      fields: [
        { key: 'dtinicio', label: 'Data Inicio', sortable: true },
        { key: 'dtfim', label: 'Data Fim', sortable: true },
        { key: 'dstipo', label: 'Tipo de Data', sortable: true },
        { key: 'actions', label: '' }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      datapagamentoboleto: this.controlePage.datapagamentoboleto,
      boletohorario: this.controlePage.boletohorario,
      dataconfirmacaopagamento: this.controlePage.dataconfirmacaopagamento,
      pixHorario: this.controlePage.pixhorario,
      horaInicial: '',
      horaFinal: '',
      horaInicialPadrao: '',
      horaFinalPadrao: '',
      criar: {
        idpublicdata: '',
        idpublicacao: this.idPublicacao,
        idpublicdatatipo: '',
        dtfim: '',
        dtinicio: '',
        dstipo: ''
      },
      tipoPublicacao: this.controlePage.idpublictipo,
      editar: {
        idpublicdata: '',
        idpublicacao: this.idPublicacao,
        idpublicdatatipo: '',
        dtfim: '',
        dtinicio: '',
        dstipo: ''
      }
    }
  },
  components: {
    fccDataTipoPublicacao
  },
  methods: {
    listandoDatas() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listandoDatasGenerico(this.idPublicacao)
        .then((response) => {
          let controlePublicacaoOk = ''
          response.data.forEach((element) => {
            if (element.dstipo === 'Publicação') {
              controlePublicacaoOk = 1
              this.liberaPublicacao = ''
              this.textoPublicacao = 'Prorrogação'
              this.criar.idpublicdatatipo = 2
              this.criar.dstipo = 'Prorrogação'
            }
          })
          if (controlePublicacaoOk === 1) {
            this.liberaPublicacao = ''
          } else {
            this.liberaPublicacao = 1
          }
          this.listagemDataPublicacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    buscaHoraPadrao() {
      axios
        .get(
          this.baseUrlPublicacao +
            'PublicacaoTipo/ListarPublicacaoTipoPorId/' +
            this.tipoPublicacao +
            '/' +
            this.controlePage.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.horaInicial = response.data.horarioiniciopadrao
          this.horaFinal = response.data.horariofimpadrao
        })
        .catch(this.setErrorSystem)
    },
    deleteField(_, item) {
      if (item.dstipo === 'Publicação') {
        this.callAlert(
          'Publicação',
          'Não é permitido excluir datas do tipo "Publicação"',
          'error',
          'error'
        )
      } else {
        this.callConfirm(this.mensagemExcluir, item.dstipo).then(() => {
          axios
            .delete(
              this.baseUrlPublicacao + 'PublicacaoData/ExcluirPublicacaoData/' + item.idpublicdata,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoDatas()
              this.callToast(this.mensagensUpdate.excluido)
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        })
      }
    },
    editarPublicacao() {
      if (this.editar.dtfim !== '' && this.editar.dtfim < this.editar.dtinicio) {
        this.callAlert('Erro ao Inserir', 'Data Final maior que a data inicial', 'error', 'error')
      } else {
        this.editar.dtinicio = this.FormataTimeStampSGP(
          this.editar.dtinicio,
          this.horaInicialPadrao
        )
        this.editar.dtfim =
          this.editar.dtfim === ''
            ? ''
            : this.FormataTimeStampSGP(this.editar.dtfim, this.horaFinalPadrao)
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .put(
            this.baseUrlPublicacao + 'PublicacaoData/AlterarPublicacaoData',
            this.editar,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoDatas()
            this.alterarDataFechamentoConcursoInscricao(this.controlePage.spi, this.editar.dtfim)
            this.carregaTexto()
            this.$root.$emit('bv::hide::modal', 'editFieldModal')
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch((error) => {
            this.$root.$emit('bv::hide::modal', 'editFieldModal')
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },
    alteraPublicacao() {
      let controlePage = this.controlePage
      controlePage.boletohorario = this.boletohorario
      if (this.controlePage.gru != null) {
        controlePage.idGRU =
          this.controlePage.gru.idcontabancaria != null
            ? this.controlePage.gru.idcontabancaria
            : this.controlePage.gru.id
      }
      controlePage.datapagamentoboleto = this.datapagamentoboleto
      controlePage.dataconfirmacaopagamento = this.dataconfirmacaopagamento
      controlePage.pixhorario = this.pixHorario
      this.$emit('alteraPublicacao', controlePage)
    },
    criarPublicacao() {
      this.criar = {
        idpublicdata: this.criar.idpublicdatatipo,
        idpublicacao: this.idPublicacao,
        idpublicdatatipo: this.criar.idpublicdatatipo,
        dtinicio: this.FormataTimeStampSGP(this.criar.dtinicio, this.horaInicial),
        dtfim: this.FormataTimeStampSGP(this.criar.dtfim, this.horaFinal),
        dstipo: this.criar.dstipo
      }
      if (this.criar.dtfim < this.criar.dtinicio) {
        this.callAlert('Erro ao Inserir', 'Data final maior que a data inicial', 'error', 'error')
      } else if (this.dataAtualSGP > this.criar.dtinicio) {
        this.callAlert(
          'Erro ao Inserir',
          'Data e hora inicial menor que data atual',
          'error',
          'error'
        )
      } else {
        this.carregaTexto(this.codeMensagem('C04'))
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoData/InserirPublicacaoData',
            this.criar,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.alterarDataFechamentoConcursoInscricao(this.controlePage.spi, this.editar.dtfim)
            this.listandoDatas()
            this.carregaTexto()
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
            this.callToast(this.mensagensUpdate.adicionado)
          })
          .catch((error) => {
            this.$root.$emit('bv::hide::modal', 'addFieldModal')
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },
    changeDataTipoPublicacao(recebe) {
      this.criar.idpublicdatatipo = recebe.idpublicdatatipo
      this.criar.dstipo = recebe.dstipo
    },
    addField() {
      this.criar.dtinicio = ''
      this.criar.dtfim = ''
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editField(_, item) {
      this.editTextoPublicacao = item.dstipo
      this.editar = {
        idpublicdata: item.idpublicdata,
        idpublicacao: item.idpublicacao,
        idpublicdatatipo: item.idpublicdatatipo,
        dtfim: this.$moment(item.dtfim, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss'),
        dtinicio: this.$moment(item.dtinicio, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss'),
        dstipo: item.dstipo
      }
      this.horaInicialPadrao = this.editar.dtinicio
      this.horaFinalPadrao = this.editar.dtfim == null ? this.horaFinal : this.editar.dtfim
      this.$root.$emit('bv::show::modal', 'editFieldModal')
    },
    verificaData(data) {
      return data === '0001-01-01T00:00:00' || data == null ? '' : data
    }
  },
  props: {
    idPublicacao: Number,
    primeiroAcesso: Boolean,
    controlePage: Object
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.pixHorario = this.verificaData(this.controlePage.pixhorario)
    this.boletohorario = this.verificaData(this.controlePage.boletohorario)
    if (!this.primeiroAcesso) {
      this.datapagamentoboleto = this.$moment(
        this.controlePage.datapagamentoboleto,
        'DD/MM/YYYY HH:mm:ss'
      ).format('YYYY-MM-DDTHH:mm:ss')
    }
    this.dataconfirmacaopagamento = this.verificaData(this.controlePage.dataconfirmacaopagamento)
    this.listandoDatas()
    this.buscaHoraPadrao()
  }
}
</script>
